export default __webpack_public_path__ + "static/media/Garabandal_Visionaries_Ecstasies_.022bf136.jpg";